import {} from 'react-redux';

import { Action } from '@reduxjs/toolkit';

import * as actionTypes from '../constants';
import { updateObject } from '../../../../shared/utils';
import { SupportChatMessageCollection } from '../../models/support-chat-message-collection';
import { AppAction } from '../../../../store';
import { SupportChatMessage } from '../../models/support-chat-messages';
import { SupportChatChat } from '../../models/support-chat-chat';

export interface SupportChatState {
  messages: SupportChatMessageCollection | null;
  messagesError: string | null;
  messagesLoading: boolean;

  localMessages: SupportChatMessageCollection | null;

  chats: SupportChatChat | null;
  chatWithInsured: SupportChatMessageCollection | null;
  chatsError: string | null;
  chatsLoading: boolean;

  selectedMessageChatItem: SupportChatMessage | null;
}

const initialState: SupportChatState = {
  messages: null,
  messagesError: null,
  messagesLoading: false,

  localMessages: null,

  chats: null,
  chatWithInsured: null,
  chatsError: null,
  chatsLoading: false,

  selectedMessageChatItem: null,
};

const getMessagesStart = (state: SupportChatState, action: AppAction<SupportChatMessageCollection>) => {
  return updateObject(state, {
    messagesError: null,
    messagesLoading: true,
  });
};

const getMessagesSuccess = (state: SupportChatState, action: AppAction<SupportChatMessageCollection>) => {
  return updateObject(state, {
    messages: action.data,
    messagesError: null,
    messagesLoading: false,
  });
};

const getMessagesFail = (state: SupportChatState, action: AppAction<SupportChatMessageCollection>) => {
  return updateObject(state, {
    messages: null,
    messagesError: action.error,
    messagesLoading: false,
  });
};

const setMessages = (state: SupportChatState, action: AppAction<any>) => {
  return updateObject(state, {
    messages: action.data,
  });
};

const setLocalMessages = (state: SupportChatState, action: AppAction<any>) => {
  return updateObject(state, {
    localMessages: action.data,
  });
};

const getChatsStart = (state: SupportChatState, action: AppAction<any>) => {
  return updateObject(state, {
    chatsError: null,
    chatsLoading: true,
  });
};

const getChatsSuccess = (state: SupportChatState, action: AppAction<any>) => {
  return updateObject(state, {
    chats: action.data,
    chatsError: null,
    chatsLoading: false,
  });
};

// const getChatWithInsuredSuccess = (state: SupportChatState, action: AppAction<SupportChatChat>) => {
//   return updateObject(state, {
//     chatWithInsured: action.data,
//     chatsError: null,
//     chatsLoading: false,
//   });
// };

const getChatsFail = (state: SupportChatState, action: AppAction<any>) => {
  return updateObject(state, {
    chats: null,
    chatsError: action.error,
    chatsLoading: false,
  });
};

const setChats = (state: SupportChatState, action: AppAction<any>) => {
  return updateObject(state, {
    chats: action.data,
  });
};

const setSelectedMessageChatItem = (state: SupportChatState, action: AppAction<any>) => {
  return updateObject(state, {
    selectedMessageChatItem: action.data,
  });
};

const reducer = (state = initialState, action: Action) => {
  switch (action.type) {
    case actionTypes.SUPPORT_CHAT_GET_MESSAGES_START:
      return getMessagesStart(state, action as AppAction<SupportChatMessageCollection>);
    case actionTypes.SUPPORT_CHAT_GET_MESSAGES_SUCCESS:
      return getMessagesSuccess(state, action as AppAction<SupportChatMessageCollection>);
    case actionTypes.SUPPORT_CHAT_GET_MESSAGES_FAIL:
      return getMessagesFail(state, action as AppAction<SupportChatMessageCollection>);

    case actionTypes.SUPPORT_CHAT_SET_MESSAGES:
      return setMessages(state, action as AppAction<any>);

    case actionTypes.SUPPORT_CHAT_SET_LOCAL_MESSAGES:
      return setLocalMessages(state, action as AppAction<any>);

    case actionTypes.SUPPORT_CHAT_GET_CHATS_START:
      return getChatsStart(state, action as AppAction<any>);
    case actionTypes.SUPPORT_CHAT_GET_CHATS_SUCCESS:
      return getChatsSuccess(state, action as AppAction<any>);
    case actionTypes.SUPPORT_CHAT_GET_CHATS_FAIL:
      return getChatsFail(state, action as AppAction<any>);

    case actionTypes.SUPPORT_CHAT_SET_CHATS:
      return setChats(state, action as AppAction<any>);

    case actionTypes.SUPPORT_CHAT_SELECTED_CHAT_ITEM:
      return setSelectedMessageChatItem(state, action as AppAction<any>);

    default:
      return state;
  }
};

export default reducer;
